<template>
  <VCard class="delivery-memo-wrapper" :color="ColorType.white">
    <VSection title="요청사항" :padding="[25, 15, 5, 15]" :useUnderline="false">
      <VBlock
        class="header-wrapper"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :padding="[15, 15, 20, 15]"
      >
        <VBlock class="rider-wrapper" :sort="Sort.space_between" :margin="[0, 0, 6, 0]">
          <VSpan
            class="rider-text"
            text="라이더님께"
            :size="14"
            :spacing="-0.35"
            :color="TextColor.gray5"
          />
          <!--<VCheckBox
            class="save-button"
            name="useMemoSave"
            :checked="delivery.useMemoSave"
            :onChecked="(event) => { changeDelivery({ useMemoSave: !delivery.useMemoSave }) }"
          >
            <VSpan class="text" text="자동저장" :size="14" />
          </VCheckBox>-->
        </VBlock>
        <!-- TODO check src/components/order/DeliveryMemo.vue:9 -->
        <VInput
          :value="deliveryMemo"
          placeholder="예) 집 앞에 두고 벨을 눌러 주세요~"
          :onChanged="(event) => { changeDelivery({ memo: event.target.value }) }"
          :maxlength="60"
          id="rider-memo"
        />
      </VBlock>
    </VSection>
  </VCard>
</template>

<script>
import VInput from '../../atoms/VInput/index'
import VCheckBox from '../../atoms/VCheckBox/index'
import VSpan, { TextColor } from '../../atoms/VSpan/index'

import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSection from '../../molecules/VSection'
import VCard, { ColorType } from '../../molecules/VCard'

export default {
  name: 'PreOrderDeliveryMemo',
  components: { VSpan, VCheckBox, VInput, VCard, VSection, VBlock },
  props: {
    delivery: {
      type: Object,
      required: true
    },
    deliveryMemo: {
      type: String,
      default: ''
    },
    changeDelivery: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      ColorType,
      Sort,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.delivery-memo-wrapper {
  width: 100%;
  height: auto;
  border-bottom: 1px solid $light-gray-5;

  .memo-wrapper {
    width: 100%;
    height: auto;

    .header-wrapper {
      width: 100%;
      height: auto;
      // padding: 16px;
      box-sizing: border-box;

      .rider-wrapper {
        align-items: center;
        height: auto;
        margin-bottom: 8px;

        .rider-text {
          // width: 100%;
          white-space: nowrap;
        }

        .save-button {
          width: auto;
          padding-right: 0;

          .text {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>
